import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import usePageTracking from "./pages/usePageTracking";

// ---------- PUBLIC WEBSITE PAGES ----------
import HomePage from "./pages/Homepage";
import AboutUs from "./pages/AboutUs";
import OurProjects from "./pages/OurProjects";
import OngoingProjectPage from "./pages/OngoingProjectPage";
import CompletedProjects from "./pages/CompletedProjects";
import Career from "./pages/Career";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy"; // ✅ Added
import TermsConditions from "./pages/TermsConditions"; // ✅ Added
import BlogsPage from "./pages/BlogsPage"; // ✅ Added
import SingleBlogPage from "./pages/SingleBlogPage"; // ✅ Added

// ---------- ADMIN AUTHENTICATION PAGES ----------
import AdminLogin from "./pages/AdminLogin";
import Signup from "./pages/Signup";
import ResetPassword from "./pages/ResetPassword";

// ---------- ADMIN DASHBOARD MAIN PAGE ----------
import AdminDashboard from "./pages/AdminDashboard";

// ---------- ADMIN DASHBOARD SUBPAGES ----------
import Home from "./pages/DashboardPages/Home";
import Footer from "./pages/DashboardPages/Footer";
import Projects from "./pages/DashboardPages/Projects";
import OngoingProjects from "./pages/DashboardPages/OngoingProjects";
import CompletedProjectsDashboard from "./pages/DashboardPages/CompletedProjects";
import CareerDashboard from "./pages/DashboardPages/Career";
import Blogs from "./pages/DashboardPages/Blogs";
import ContactUsDashboard from "./pages/DashboardPages/ContactUs";
import Trustbar from "./pages/DashboardPages/Trustbar";
import About from "./pages/DashboardPages/About";
import UserAdminPage from "./pages/UserAdminPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import ContactUsMessages from "./pages/ContactUsMessages";
import ProtectedRoute from "./components/protected route/ProtectedRoute";
import CompletedProjectPage from "./pages/completedProjectsPage";
import CreateProjects from "./pages/DashboardPages/CreateProject";
import DraftProjectPage from "./pages/DashboardPages/DraftProjects";
import EmailSettings from './pages/DashboardPages/EmailSettings';


function PageTrackingWrapper() {
  usePageTracking();   
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
       <PageTrackingWrapper/>
      <div className="App">
        <Routes>
          {/* ---------- PUBLIC WEBSITE ROUTES ---------- */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/projects" element={<OurProjects />} />
          {/* <Route path="/projects/:projectId" element={<OngoingProjectPage />} /> */}
          <Route path="/projects/:slug" element={<OngoingProjectPage />} />
          <Route
            path="/completed-projects/:projectId"
            element={<CompletedProjectPage />}
          />
          <Route
            path="/completed-projects/:projectId"
            element={<CompletedProjects />}
          />
          <Route path="/career" element={<Career />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/blogs" element={<BlogsPage />} /> 
          <Route path="/blogs/:slug" element={<SingleBlogPage />} />
          {/* <Route path="/blogs/:blogId" element={<SingleBlogPage />} />  */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* ✅ Added */}
          <Route path="/terms-conditions" element={<TermsConditions />} /> {/* ✅ Added */}

          {/* ---------- ADMIN ROUTES ---------- */}

          {/* ---------- ADMIN AUTH ROUTES ---------- */}
          <Route path="/admin-login" element={<AdminLogin />} />
          {/* ✅ Signup now protected */}
          <Route
            path="/signup"
            element={<ProtectedRoute element={Signup} />}
          />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* ---------- ADMIN DASHBOARD ROUTES ---------- */}
          <Route
            path="/dashboard"
            element={<ProtectedRoute element={AdminDashboard} />}
          />

          {/* Main Home section (renamed from DashboardPage) */}
          <Route
            path="/dashboard/home"
            element={<ProtectedRoute element={Home} />}
          />

          {/* Dashboard subpages under DashboardPages */}
          <Route
            path="/dashboard/footer"
            element={<ProtectedRoute element={Footer} />}
          />
          <Route
            path="/dashboard/projects"
            element={<ProtectedRoute element={Projects} />}
          />
          <Route
            path="/dashboard/ongoing-projects"
            element={<ProtectedRoute element={OngoingProjects} />}
          />
          <Route
            path="/dashboard/draft-projects"
            element={<ProtectedRoute element={DraftProjectPage} />}
          />
          <Route
            path="/dashboard/completed-projects"
            element={<ProtectedRoute element={CompletedProjectsDashboard} />}
          />
          <Route
            path="/dashboard/create-projects"
            element={<ProtectedRoute element={CreateProjects} />}
          />
          <Route
            path="/dashboard/career"
            element={<ProtectedRoute element={CareerDashboard} />}
          />
          <Route
            path="/dashboard/blogs"
            element={<ProtectedRoute element={Blogs} />}
          />
          <Route
            path="/dashboard/contact-us"
            element={<ProtectedRoute element={ContactUsDashboard} />}
          />
          <Route
            path="/dashboard/trustbar"
            element={<ProtectedRoute element={Trustbar} />}
          />
          <Route
            path="/dashboard/about"
            element={<ProtectedRoute element={About} />}
          />

          {/* Other dashboard-related routes */}
          <Route
            path="/dashboard/user-admin"
            element={<ProtectedRoute element={UserAdminPage} />}
          />

          <Route
            path="/dashboard/change-password"
            element={<ProtectedRoute element={ChangePasswordPage} />}
          />

          <Route
            path="/dashboard/contact-queries"
            element={<ProtectedRoute element={ContactUsMessages} />}
          />
          <Route 
         path="/dashboard/email-settings" 
        element={<ProtectedRoute element={EmailSettings} />} 
        />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
